import { Empresa } from '../../models/cadastro.model';
import { formatarDocumento, somenteDigitos } from './documento.util';

function texto(valor: string | null | undefined): string {
  return (valor ?? '').trim();
}

/** 14 dígitos -> 00.000.000/0000-00; caso contrário devolve o original. */
export function formatarCnpj(valor: string | null | undefined): string {
  if (valor == null) return '';
  return somenteDigitos(valor).length === 14 ? formatarDocumento(valor) : valor;
}

/** 10 -> (00) 0000-0000; 11 -> (00) 00000-0000; caso contrário devolve o original. */
export function formatarTelefone(valor: string | null | undefined): string {
  if (valor == null) return '';
  const d = somenteDigitos(valor);
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  return valor;
}

/** "endereco, numeroPredial - cidade/UF - CEP", omitindo partes vazias. */
export function montarEnderecoEmpresa(
  e: Pick<Empresa, 'endereco' | 'numeroPredial' | 'cidade' | 'estado' | 'cep'> | null | undefined,
): string {
  if (!e) return '';
  const logradouro = [texto(e.endereco), texto(e.numeroPredial)].filter(Boolean).join(', ');
  const cidade = texto(e.cidade);
  const uf = texto(e.estado);
  const local = [cidade, uf].filter(Boolean).join('/');
  return [logradouro, local, texto(e.cep)].filter(Boolean).join(' - ');
}
